const ProposalRedistributionEnum = Object.freeze({
    RETURN: 'RETURN',
    REALLOCATE: 'REALLOCATE',
    RETURN_TOTAL: 'RETURN_TOTAL',
    REALLOCATE_EQUALLY: 'REALLOCATE_EQUALLY',
    REALLOCATE_APPLIED: 'REALLOCATE_APPLIED'
});

export default ProposalRedistributionEnum;
